import styled from '@emotion/styled';

import Icon from 'components/global/Icon';

import { Breakpoints } from 'utils/const.styles';

import { ModalActions } from './Modal.styled';

export const Container = styled.div`
	width: fit-content;
	height: fit-content;
	cursor: pointer;
	position: relative;

	img {
		border-radius: var(--small-border-radius);
	}
`;
export const OverlayContainer = styled.div`
	position: absolute;
	top: 0;
	z-index: 9;
	width: 100%;
	height: 100%;

	border-radius: var(--small-border-radius);
	border: 1px solid var(--border-color);
	transition: all 0.2s ease-in-out;

	> svg {
		display: block;
	}
	:hover {
		background-color: rgba(0, 0, 0, 0.1);
	}
`;
export const Header = styled.div`
	display: flex;
	margin-top: -1.2rem;
	> div:last-of-type {
		margin-left: var(--margin-3);
		body[dir='rtl'] & {
			margin-left: 0;
			margin-right: var(--margin-3);
		}
	}
	@media ${Breakpoints.tablet && Breakpoints.mobile} {
		padding: var(--margin-2) var(--margin-3) var(--margin-1) var(--margin-3);
	}
`;
export const IconStyled = styled(Icon)`
	display: none;
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	left: 0;
	right: 0;
	margin: auto;
	font-size: 3rem !important;
	color: white;
	padding: 1rem 1.5rem;
	border-radius: 50%;
	background-color: #0000002e;
`;

export const ModalBottom = styled(ModalActions)`
	justify-content: flex-start;
	@media ${Breakpoints.tablet} {
		* {
			background-color: var(--red);
			display: none;
		}
	}
`;
